export const parseRatingQueryParam = (value: string | null): number | null =>
  value?.length === 1 && /^[1-5]$/.test(value) ? Number(value) : null;
